import { create } from "zustand";
import { updateVideoPlaylist } from "../helper/useApiHelper";
import { currentAllPlaylistIdAPI } from "../constants/sharedPlaylist";

const usePlayListStore = create((set) => ({
  allPlaylists: new Map(),
  allPlaylistsId: new Map(currentAllPlaylistIdAPI),
  cacheAllNewPlaylists: new Map(),
  countPlaylists: 0,
  isUpdatedPlaylist: false,
  playlistState: new Map(),
  currentPlayingPlaylist: null,
  getCurrentPlaylist: (playlistDetails, key) => {
    set((state) => {
      const allCurrentPlaylists = new Map(state.allPlaylists);
      if (allCurrentPlaylists.size > 0) {
        if (
          allCurrentPlaylists.has(key) &&
          !playlistDetails.name &&
          !playlistDetails.videos
        ) {
          allCurrentPlaylists.delete(key);
        }
      }

      if (playlistDetails.name && playlistDetails.videos) {
        allCurrentPlaylists.set(playlistDetails.name, playlistDetails.videos);
      }
      return {
        allPlaylists: new Map(allCurrentPlaylists),
        countPlaylists: allCurrentPlaylists.size,
      };
    });
  },
  createPlaylistId: (playlistName, playlistId) => {
    set((state) => {
      const allCurrentPlaylistsId = new Map(state.allPlaylistsId);
      allCurrentPlaylistsId.set(playlistName, playlistId);
      return {
        cacheAllNewPlaylists: new Map(allCurrentPlaylistsId),
      };
    });
  },
  createPlaylist: (playlistName) => {
    set((state) => {
      const allCurrentPlaylists = new Map(state.allPlaylists);
      if (!allCurrentPlaylists.has(playlistName)) {
        allCurrentPlaylists.set(playlistName, []);
      }
      return {
        allPlaylists: new Map(allCurrentPlaylists),
        countPlaylists: allCurrentPlaylists.size,
      };
    });
  },
  addVideo: (playlistName, videoDetails) => {
    set((state) => {
      const allCurrentPlaylists = new Map(state.allPlaylists);
      if (allCurrentPlaylists.has(playlistName)) {
        const currentItems = allCurrentPlaylists.get(playlistName) || [];
        currentItems.push({ ...videoDetails });
        allCurrentPlaylists.set(playlistName, currentItems);
      }

      return {
        allPlaylists: new Map(allCurrentPlaylists),
      };
    });
  },
  updateVideo: (currentVideoDetails, currentState) => {
    set((state) => {
      const allCurrentPlaylists = new Map(state.allPlaylists);
      const allCurrentPlaylistsId = new Map(state.allPlaylistsId);
      let status = [];
      for (let [key, videos] of allCurrentPlaylists.entries()) {
        if (currentState && currentState.has(key)) {
          let updateVideos = [];
          let isUpdateVideo = false;
          const currentVideoStatus = currentState.get(key);
          for (let video of videos) {
            // filter video
            if (
              (video.videoId === currentVideoDetails.videoId &&
                currentVideoStatus) ||
              video.videoId !== currentVideoDetails.videoId
            ) {
              updateVideos.push({ ...video });
            } else {
              // Remove video
              isUpdateVideo = true;
            }
          }
          // Add new video
          if (
            updateVideos.findIndex(
              (video) => video.videoId === currentVideoDetails.videoId
            ) === -1 &&
            currentVideoStatus
          ) {
            isUpdateVideo = true;
            updateVideos.push({ ...currentVideoDetails });
          }
          if (isUpdateVideo) {
            status.push(true);
            updateVideoPlaylist(
              allCurrentPlaylistsId.get(key),
              key,
              updateVideos
            );
          }
          allCurrentPlaylists.set(key, updateVideos);
        }
      }
      return {
        allPlaylists: new Map(allCurrentPlaylists),
        isUpdatedPlaylist: status.some((it) => it),
      };
    });
  },
  setCurrentPlayingPlaylist: (playlist) => {
    set({ currentPlayingPlaylist: { ...playlist } });
  },
  updateCurrentPlayingPlaylistStatus: (index, isPlayingStatus) => {
    set((state) => {
      let currentPlayingPlaylist = state.currentPlayingPlaylist;
      let temp = [];
      let i = 0;
      for (const video of currentPlayingPlaylist.videos) {
        if (i === index) {
          temp.push({
            ...video,
            isPlayingNow: isPlayingStatus,
          });
        } else {
          temp.push({ ...video });
        }
        i++;
      }
      currentPlayingPlaylist = {
        name: currentPlayingPlaylist.name,
        videos: temp,
      };
      return {
        currentPlayingPlaylist: { ...currentPlayingPlaylist },
      };
    });
  },
  removePlaylist: () => {},
  checkVideoInPlaylist: (videoId) => {
    set((state) => {
      const allCurrentPlaylists = new Map(state.allPlaylists);
      let playlistState = new Map();
      for (let [key, videos] of allCurrentPlaylists.entries()) {
        if (!videos) {
          allCurrentPlaylists.delete(key);
        } else {
          if (videos.length === 0) {
            playlistState.set(key, false);
          } else {
            for (let video of videos) {
              if (video.videoId === videoId) {
                playlistState.set(key, true);
                break;
              } else {
                playlistState.set(key, false);
              }
            }
          }
        }
      }
      return {
        allPlaylists: new Map(allCurrentPlaylists),
        playlistState: new Map(playlistState),
      };
    });
  },
  clearCurrentPlayingPlaylist: () => {
    set({ currentPlayingPlaylist: null });
  },
  resetIsUpdatedPlaylist: () => {
    set({ isUpdatedPlaylist: false });
  },
  reset: () =>
    set({
      allPlaylists: new Map(),
      allPlaylistsId: new Map(),
      countPlaylists: 0,
      isUpdatedPlaylist: false,
      playlistState: new Map(),
    }),
}));

export default usePlayListStore;
